import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

const ReserveButton = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const [showLabel, setShowLabel] = useState(false); // Default hidden at top

    useEffect(() => {
        const handleScroll = () => {
            // Show label when scrolled DOWN (> 300), hide when at TOP (<= 300)
            setShowLabel(window.scrollY > 300);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Only show on /explore page
    if (location.pathname !== '/explore') {
        return null;
    }

    // Button is ALWAYS visible on Explore page (removed scroll check for button itself)

    const handleReserveClick = () => {
        if (location.pathname !== '/') {
            navigate('/');
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <button
            onClick={handleReserveClick}
            className="fixed bottom-6 left-6 z-50 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-full p-4 shadow-2xl hover:shadow-blue-500/50 hover:scale-110 transform transition-all duration-300 group"
            aria-label="Reserve a ride"
        >
            {/* Calendar/Reserve Icon */}
            <svg
                className="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>

            {/* Tooltip - Positioned to the right for left-side button */}
            <span className={`absolute left-full ml-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap pointer-events-none shadow-lg transition-opacity duration-300 ${showLabel ? 'opacity-100' : 'opacity-0'}`}>
                {t('common.reserve_label')}
            </span>

            {/* Pulse effect */}
            <span className="absolute inset-0 rounded-full bg-blue-500 opacity-75 animate-ping"></span>
        </button>
    );
};

export default ReserveButton;
